import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from 'models/field.interface';
@Component({
  template: `
    <div [formGroup]="group">
      <button class="btn btn-primary bd-0 mt-2" type="submit">{{field.label}}</button>
    </div>`,
})

export class ButtonComponent {
  field: FieldConfig;
  group: FormGroup;
}
